export default "__VITE_ASSET__De8MWFCb__"